/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './baBackTop.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../app/theme/components/baBackTop/baBackTop.component';
const styles_BaBackTop:any[] = [i0.styles];
export const RenderType_BaBackTop:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_BaBackTop,
    data:{}});
export function View_BaBackTop_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{_selector:0}),(_l()(),i1.ɵted(-1,(null as any),
      ['\n    '])),(_l()(),i1.ɵeld(2,0,[[1,0],['baBackTop',1]],(null as any),0,'i',
      [['class','fa fa-angle-up back-top ba-back-top'],['title','Back to Top']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
      (null as any),['\n  ']))],(null as any),(null as any));
}
export function View_BaBackTop_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'ba-back-top',
      ([] as any[]),(null as any),[[(null as any),'click'],['window','scroll']],(_v,
          en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1)._onClick()) !== false);
          ad = (pd_0 && ad);
        }
        if (('window:scroll' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,1)._onWindowScroll()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },View_BaBackTop_0,RenderType_BaBackTop)),i1.ɵdid(1,4243456,(null as any),0,
      i2.BaBackTop,([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const BaBackTopNgFactory:i1.ComponentFactory<i2.BaBackTop> = i1.ɵccf('ba-back-top',
    i2.BaBackTop,View_BaBackTop_Host_0,{position:'position',showSpeed:'showSpeed',
        moveSpeed:'moveSpeed'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL3RoZW1lL2NvbXBvbmVudHMvYmFCYWNrVG9wL2JhQmFja1RvcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL3RoZW1lL2NvbXBvbmVudHMvYmFCYWNrVG9wL2JhQmFja1RvcC5jb21wb25lbnQudHMiLCJuZzovLy9EOi9pbmV0cHViL3d3d3Jvb3Qva2FpemVuLW5nL3NyYy9hcHAvdGhlbWUvY29tcG9uZW50cy9iYUJhY2tUb3AvYmFCYWNrVG9wLmNvbXBvbmVudC50cy5CYUJhY2tUb3AuaHRtbCIsIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC90aGVtZS9jb21wb25lbnRzL2JhQmFja1RvcC9iYUJhY2tUb3AuY29tcG9uZW50LnRzLkJhQmFja1RvcF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxpICNiYUJhY2tUb3AgY2xhc3M9XCJmYSBmYS1hbmdsZS11cCBiYWNrLXRvcCBiYS1iYWNrLXRvcFwiIHRpdGxlPVwiQmFjayB0byBUb3BcIj48L2k+XG4gICIsIjxiYS1iYWNrLXRvcD48L2JhLWJhY2stdG9wPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozt1RENBQTtNQUFBLGFBQ0k7TUFBQTtNQUFBLDBEQUFrRjtNQUFBOzs7b0JDRHRGO01BQUE7bUJBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBLGlEQUFBO21CQUFBOzs7OyJ9



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/theme/components/baBackTop/baBackTop.component.ngfactory.ts